module.exports = __webpack_public_path__ + "img/full1-min.deaa0c67.png";